const KEY = "lookers_recently_viewed";
const MAX = 8;

export function getRecentlyViewed() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(raw) ? raw.filter((id) => typeof id === "string") : [];
  } catch {
    return [];
  }
}

export function pushRecentlyViewed(id) {
  if (!id) return;
  const next = [id, ...getRecentlyViewed().filter((x) => x !== id)].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* storage unavailable */
  }
}
